import React from "react";
import "./drawer-toggle-button.css";

const OpenCloseButton = (props) => {
  const defaultBgColor = props.defaultBgColor
  const drawerBgColor = props.drawerBgColor
  const textColor = props.collapsedDrawerTextColor
  const sessionTimeoutValue = props.drawerSessionTimeoutValue
  const sessionType = props.drawerSessionType
  const showDrawerCondition = props.showDrawer
  return (
    <button
      className="drawerToggleButton text-size-70"
      style={{ backgroundColor: `${drawerBgColor !== "" ? drawerBgColor : defaultBgColor}` }}
      onClick={() => {
        props.toggleDrawer(sessionTimeoutValue, sessionType)
        props.setDefaultIntervalFunc()
      }}
    >
      <span
        className={`drawerToggleControler ${
          !showDrawerCondition ? "drawerClose" : "drawerOpen"
        }`}
        style={{ marginTop: `${!showDrawerCondition ? "-14px" : "-8px"}` , color: `${textColor}` }}
      >
        <i className="ggdsicon-angle-down"></i>
      </span>
    </button>
  );
};

export default OpenCloseButton;
